import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SmartLabelService } from '../smart-label.service';
import { PageService } from '../../../services/page.service';
import { AppService } from '../../../services/app.service';
import { ShortCodePipe } from "../../../pipes/short-code.pipe";
import { SUP_LANG } from '../SUP_LANG';
import { MultiLangPipe } from "../../../pipes/multi-lang.pipe";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-smart-label-supplement',
  templateUrl: './smart-label-supplement.component.html',
  styleUrls: ['./smart-label-supplement.component.scss'],
})
export class SmartLabelSupplementComponent implements OnInit, OnDestroy {
  @Input() config;
  @Input() smartLabelData;
  @Input() entityInformation;

  pageAlias = '';
  privacyPolicyUrl;

  //Configs
  tabConfig: any = { config: null };
  headerConfig: any;
  productHeaderConfig: any;
  footerLinksConfig;
  footer1Config: any;
  footer2Config: any;
  socialLinksConfig: any;
  gpcCategoryCodePath: string = 'data.modules.BasicProductInformationModuleType.gpcCategoryCode';
  brandNamePath: string = 'data.modules.BasicProductInformationModuleType.brandNameInformation.brandName';
  categoryPath: string = 'data.modules.BasicProductInformationModuleType.gpcCategoryCode';
  productImageUrlPath: string = 'data.modules.BasicProductInformationModuleType.imageLink';
  badgeConfig: any;
  informationAccuracyConfig: any;
  allergensSupHeaderConfig: any;
  allergensSupListConfig: any;
  allergenCodes_USA: Array<string> = ['AM', 'AE', 'AF', 'UN', 'TN', 'AP', 'UW', 'AY'];
  allergenCodes_CA: Array<string> = ['AM', 'AE', 'AF', 'UN', 'TN', 'AP', 'UW', 'AY', 'BM', 'AS'];
  servingSizeSelectorConfig: any;
  supplementFactsConfig: any
  supplementFactsList: Array<string> = ['FAT', 'FASAT', 'FATRN', 'FAPU', 'FAMS', 'CHOL-', 'NA', 'CHO-', 'FIBTG', 'SUGAR-', 'SUGAD', 'PRO-', 'VITD-', 'CA', 'FE', 'K', 'VITD-', 'CA', 'FE', 'K', 'VITA-', 'VITC-', 'VITE-', 'VITK', 'THIA', 'RIBF', 'NIA', 'VITB6-', 'FOL-', 'VITB12', 'BIOT', 'PANTAC', 'P', 'ID', 'MG', 'ZN', 'SE', 'CU', 'MN', 'CR', 'MO', 'CLD', 'CHOLN'];
  servingSizeSubscription: Subscription;
  ingredientsListConfig: any;
  ingredientsPath = 'data.modules.FoodAndBeverageIngredientInformationModuleType';

  constructor(
    private smartLabelService: SmartLabelService,
    private pageService: PageService,
    private appService: AppService,
    public shortCodePipe: ShortCodePipe,
    public multiLangPipe: MultiLangPipe
  ) { }

  /**
   * Header and Footer for the Supplements Smartlabel digital Interaction
   * @author - Venkatesh Pasala
   * @task - QLIKTAG-3654
   */
  ngOnInit() {
    this.pageAlias = this.pageService.pageAlias;
    this.smartLabelService.smartLabelData = this.smartLabelData;
    this.smartLabelService.smartLabelConfig = this.config;
    this.privacyPolicyUrl = this.smartLabelService.getPrivacyPolicyUrl(this.config);
    this.socialLinksConfig = this.smartLabelService.getSocialLinksConfig();
    this.badgeConfig = this.smartLabelService.getBadgeConfig();
    this.informationAccuracyConfig = this.smartLabelService.getInformationAccuracyConfig();
    this.allergensSupHeaderConfig = this.getAllergensSupHeaderConfig();
    this.allergensSupListConfig = this.getAllergensSupListConfig();

    this.servingSizeSelectorConfig = this.getServingSizeSelectorConfig();
    this.supplementFactsConfig = this.getSupplementFactsConfig(0);
    this.ingredientsListConfig = this.getIngredientsList();


    this.headerConfig = {
      "ctrlName": "header",
      "config": {
        "sticky": true,
        "isBackButtonVisible": false,
        "isMenuButtonVisible": false,
        "isContentHeader": true,
        "bgImageColor": "#FFFFFF",
        "class": 'smartlabel-header'
      }
    }


    this.productHeaderConfig = this.smartLabelService.getProductHeaderConfig();

    if (this.config.hasOwnProperty('footer1')) {
      this.footer1Config = {
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text smartlabel-footer m-b-10",
          "content": this.config.footer1,
        }
      }
    }
    if (this.config.hasOwnProperty('footer2')) {
      this.footer2Config = {
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text smartlabel-footer",
          "content": this.config.footer2,
        }
      }
    }
    this.footerLinksConfig = {
      "ctrlName": "footer-links",
      "config": {
        "class": "smartlabel-footer-links",
        "links": [
          ...(this.privacyPolicyUrl ? [this.privacyPolicyUrl] : [])
        ]
      }
    }
    this.tabConfig =
    {
      "ctrlName": "tabs",
      "config": {
        "class": 'smartlabel-tabs',
        "value": this.smartLabelService.getTabName(0),
        "layout": 'icon-top',
        "scrollable": false,
        "tabs": 5,
        "sticky": true,
        "gridFixed": true
      },
      "controls": [
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(0),
            "title": this.smartLabelService.getTabTitle(0),
            "icon": this.smartLabelService.getTabIcon(0),
            "show": true
          },
          "controls": [
            ...(this.servingSizeSelectorConfig ? [this.servingSizeSelectorConfig] : []),
            ...(this.supplementFactsConfig ? [this.supplementFactsConfig] : [])
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(1),
            "title": this.smartLabelService.getTabTitle(1),
            "icon": this.smartLabelService.getTabIcon(1),
            "show": true
          },
          "controls": [
            ...(this.ingredientsListConfig ? [this.ingredientsListConfig] : [])
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(2),
            "title": this.smartLabelService.getTabTitle(2),
            "icon": this.smartLabelService.getTabIcon(2),
            "show": true
          },
          "controls": [
            ...(this.allergensSupHeaderConfig ? this.allergensSupHeaderConfig : []),
            ...(this.allergensSupListConfig ? this.allergensSupListConfig : [])
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(3),
            "title": this.smartLabelService.getTabTitle(3),
            "icon": this.smartLabelService.getTabIcon(3),
            "show": true
          },
          "controls": [
            this.getSupFeaturesAndBenefitsConfig()
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(4),
            "title": this.smartLabelService.getTabTitle(4),
            "icon": this.smartLabelService.getTabIcon(4),
            "show": true
          },
          "controls": [
            this.smartLabelService.getContactTabsConfig(),
            this.smartLabelService.getExternalLinksConfig(this.config)
          ]
        }
      ]
    }
    this.servingSizeSubscription = this.smartLabelService.smartLabelEvents$.subscribe((data) => {
      //console.log("subscribe tp event" , data)

      if (data.hasOwnProperty("payload") && data['payload'].hasOwnProperty('type')) {
        if (data['payload']['type'] === 'serving-size') {
          //console.log("nutrientHeaderConfig", this.nutrientHeaderConfig);
          //get nutrient facts config for selected index of nutrientHeader
          this.supplementFactsConfig = this.getSupplementFactsConfig(data['payload']['value']);
          //replace conditional control for USA 
          //console.log(this.supplementFactsConfig)
          //console.log("tabConfig", this.tabConfig.controls[0])
          this.tabConfig.controls[0].controls[1] = this.supplementFactsConfig;
        }
      }
    });
  }

  /**
   * Get Features and Benefits
   * @author Venkatesh Pasala
   * @task QLIKTAG-3654
   */
  getSupFeaturesAndBenefitsConfig() {
    let listConfig;
    let item;
    listConfig = {
      "ctrlName": "list",
      "title": "Features & Benefits",
      "config": {
        "class": "smartlabel-list",
      },
      "controls": []
    };
    if (this.smartLabelService.getAboutProductSupPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": SUP_LANG["feature-and-benefits"],
          "url": { "url": `p/${this.pageAlias}?detail=sup-about-this-product`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    if (this.smartLabelService.getCertificationsSupPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": SUP_LANG["certifications"],
          "url": { "url": `p/${this.pageAlias}?detail=sup-certifications-item`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    if (this.smartLabelService.getProductUsageAndSafetySupPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": SUP_LANG["health-safety"],
          "url": { "url": `p/${this.pageAlias}?detail=sup-health-and-safety`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    if (this.smartLabelService.getProductInstructionsSupPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": SUP_LANG["product-instructions"],
          "url": { "url": `p/${this.pageAlias}?detail=sup-product-instructions`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    return listConfig;
  }

  /** 
  * get allergens for supplement header config
  * @author Venkatesh Pasala
  * @task QLIKTAG-3654
  */
  getAllergensSupHeaderConfig() {
    let listConfig = [];
    let attributeKey = 'product.targetMarket';
    if (this.smartLabelService.isProductEntity) {
      attributeKey = 'targetMarket';
    }
    listConfig.push({
      "ctrlName": "conditional",
      "config": {
        "source": "entityInformation",
        "action": "show",
        "operator": "matches",
        "mapping": {
          "attributeKey": attributeKey
        },
        "attributeValue": "840"
      },
      "controls": [
        {
          "ctrlName": "jumbotron",
          "config": {
            "class": "smartlabel-jumbotron m-r-15 m-l-15",
            "content": SUP_LANG["allergens-info"]
          }
        }
      ]
    });
    listConfig.push({
      "ctrlName": "conditional",
      "config": {
        "source": "entityInformation",
        "action": "show",
        "operator": "matches",
        "mapping": {
          "attributeKey": attributeKey
        },
        "attributeValue": "124"
      },
      "controls": [
        {
          "ctrlName": "jumbotron",
          "config": {
            "class": "smartlabel-jumbotron m-r-15 m-l-15",
            "content": SUP_LANG["ca-allergens-info"]
          }
        }
      ]
    });
    return listConfig;
  }

  /**
   * get allergens list for supplement 
   * @author Venkatesh Pasala
   * @task QLIKTAG-3654
   */
  getAllergensSupListConfig() {
    let allergensListResult = [];
    let allergensInfoList = this.getAllergensFoodList();
    if (allergensInfoList && allergensInfoList.controls && allergensInfoList.controls.length) {
      allergensListResult.push({
        "ctrlName": "list",
        "config": {
          "class": "smartlabel-list m-l-15 m-r-15"
        },
        "controls": [
          allergensInfoList
        ]
      });
    } else {
      allergensListResult.push({
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text p-30",
          "content": SUP_LANG["no-allergens"]
        }
      });
    }
    return allergensListResult;
  }

  /**
    * get allergen listItem
    * @author Venkatesh Pasala
    * @task QLIKTAG-3654
    */
  getAllergensFoodList() {
    let allergensList: any;
    allergensList = {
      "ctrlName": "list",
      "config": {
        "class": "smartlabel-list"
      },
      "controls": []
    }
    let allergenRelatedInformationPath = "data.modules.ProductAllergenInformationModuleType.allergenRelatedInformation";
    let path = allergenRelatedInformationPath.split(".");
    let allergenRelatedInformation = this.appService.findObjectByPath(this.smartLabelData, path);

    //console.log({allergenRelatedInformation});
    let targetMarket = '840'

    const targetMarketPath = 'product.targetMarket';
    path = targetMarketPath.split('.');
    targetMarket = this.appService.findObjectByPath(this.smartLabelData, path);
    let allergenCodes = [];


    if (targetMarket) {

      if (targetMarket == '840') {
        allergenCodes = this.allergenCodes_USA;
      } else {
        allergenCodes = this.allergenCodes_CA;
      }

    }

    //console.log({allergenCodes});


    let allergenTypeCode = '';
    let levelOfContainmentCode = '';
    if (allergenRelatedInformation && allergenRelatedInformation.length > 0) {

      allergenCodes.forEach((ac, acIndex) => {

        allergenRelatedInformation.map((element, allergenRelatedInformationIndex) => {
          if (element.hasOwnProperty("allergen") && Array.isArray(element.allergen)) {
            if (element.allergen.length > 0) {

              //CHECK if AC is present in allergen array

              let found = element.allergen.findIndex((a) => {
                return ac.toLowerCase() == a.allergenTypeCode.toLowerCase();
              });

              if (found != -1) {
                //console.log({ac, found});

                let allergenListItem = this.formatAllergenListItem(
                  allergenRelatedInformationPath,
                  allergenRelatedInformationIndex,
                  found

                );
                if (allergenListItem) {
                  allergensList.controls.push(allergenListItem);


                }


              }


            }
          }
        });



      });


      //REPEAT FOR ADDITIONAL ITEMS
      allergenRelatedInformation.map((element, allergenRelatedInformationIndex) => {
        if (element.hasOwnProperty("allergen") && Array.isArray(element.allergen)) {
          if (element.allergen.length > 0) {

            element.allergen.forEach((a, index) => {

              let found = allergenCodes.findIndex((ac) => {
                return ac.toLowerCase() == a.allergenTypeCode.toLowerCase();
              });

              if (found == -1) {
                let allergenListItem = this.formatAllergenListItem(
                  allergenRelatedInformationPath,
                  allergenRelatedInformationIndex,
                  index

                );

                if (allergenListItem) {
                  allergensList.controls.push(allergenListItem);
                }
              }


            });
          }
        }
      });


      return allergensList;
    }
  }

  /**
   * Format allergen item into listItemConfig
   * @param allergenRelatedInformationPath: Allergen Information array containing subarrays
   * @param allergenRelatedInformationIndex: Index of subarray
   * @param found: index of item in subarray
   * @author Neil C
   * @task QLIKTAG-3694
   */
  formatAllergenListItem(allergenRelatedInformationPath, allergenRelatedInformationIndex, found) {
    let listItem;

    let allergenTypeCode = this.shortCodePipe.transform(`{{SL.${allergenRelatedInformationPath}.${allergenRelatedInformationIndex}.allergen.${found}.allergenTypeCode | mapTo: listItemName}}`);

    let levelOfContainmentCode = this.shortCodePipe.transform(`{{SL.${allergenRelatedInformationPath}.${allergenRelatedInformationIndex}.allergen.${found}.levelOfContainmentCode | mapTo: listItemName}}`);

    //console.log(allergenTypeCode, levelOfContainmentCode)

    if (allergenTypeCode && levelOfContainmentCode) {
      listItem = {
        "ctrlName": "list-item",
        "config": {
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15",
          "label": `
          <ion-badge class="smartlabel-badge" mode="ios" style="float: right;">${levelOfContainmentCode}</ion-badge>
          <ion-label class="smartlabel-list m-0" mode="ios">${allergenTypeCode}</ion-label>
          `,
          "url": { "url": `p/${this.pageAlias}?detail=allergen-item&listIndex=${allergenRelatedInformationIndex}_${found}`, "type": "detail" }
        }
      };
    }



    return listItem;
  }
  /**
   * smartlabel selector (display when more than 1 header present)
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getServingSizeSelectorConfig() {
    let result;
    let nutrientHeaderPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader`;
    let path = nutrientHeaderPath.split('.');
    const nutrientHeader = this.appService.findObjectByPath(this.smartLabelData, path);
    let options: Array<any> = [];

    if (nutrientHeader && Array.isArray(nutrientHeader) && nutrientHeader.length > 1) {
      //check for servingSizeDescription in nutrientHeader array
      nutrientHeader.map((item, index) => {
        //check if servingSizeDescriptionProperty is present
        if (item.hasOwnProperty('servingSizeDescription')) {
          let label = this.multiLangPipe.transform(item['servingSizeDescription']);
          if (label && label != '') {
            options.push({
              "label": `${label}`,
              "value": index
            })
          } //check if servingSize property is present
        } else if (item.hasOwnProperty('servingSize') && Array.isArray(item['servingSize'])) {
          let label = '';
          if (item['servingSize'].length > 0) {
            item['servingSize'].map((element, servingSizeIndex) => {
              let measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientHeaderPath}.${index}.servingSize.${servingSizeIndex}.measurementUnitCode | mapTo: listItemName}}`);
              if (servingSizeIndex == 0) {
                label += `${element['value']} ${measurementUnitCode}`;
              } else {
                label += ` (${element['value']} ${measurementUnitCode})`;
              }
            });
            //format selector options
            if (label && label != '') {
              options.push({
                "label": `${label}`,
                "value": index
              });
            }
          }
        }
      });

      //format result
      result = {
        "ctrlName": "smartlabel-selector",
        "config": {
          "type": "serving-size",
          "options": options,
          "class": "smartlabel-selector m-b-15"
        }
      };
    }
    return result;
  }


  /**
   * conditional control for USA supplement smartlabel
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getSupplementFactsConfig(index: number = 0) {
    let supplementFactsList = this.getSupplementFactsList(index);
    let supplementFacts = [
      {
        "languageCode": "en",
        "value": "Supplement Facts"
      },
      {
        "languageCode": "fr",
        "value": "Faits Supplément"
      },
      {
        "languageCode": "fr_US",
        "value": "Faits Supplément"
      },
      {
        "languageCode": "en_US",
        "value": "Supplement Facts"
      }
    ];
    let supplementFactsText = this.multiLangPipe.transform(supplementFacts);
    let footer = [
      {
        "languageCode": "en",
        "value": `* The % Daily Value (DV) tells you how much of a nutrient is in a serving of food which contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.<br />`
      },
      {
        "languageCode": "fr",
        "value": `* % valeur quotidienne vous indique la quantité d'un nutriment dans une portion de nourriture qui contribue à une alimentation quotidienne. 2000 calories par jour sont utilisées pour des conseils nutritionnels généraux.<br/>`
      },
      {
        "languageCode": "fr_US",
        "value": `* % valeur quotidienne vous indique la quantité d'un nutriment dans une portion de nourriture qui contribue à une alimentation quotidienne. 2000 calories par jour sont utilisées pour des conseils nutritionnels généraux.<br/>`
      },
      {
        "languageCode": "en_US",
        "value": `* The % Daily Value (DV) tells you how much of a nutrient is in a serving of food which contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.<br/>`
      }
    ];
    let footerText = this.multiLangPipe.transform(footer);

    let dailyValueIntakeReference;
    let nutrientHeaderPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}`
    let path = nutrientHeaderPath.split('.');
    const nutrientHeader = this.appService.findObjectByPath(this.smartLabelData, path);

    if (nutrientHeader && nutrientHeader.hasOwnProperty('dailyValueIntakeReference') && nutrientHeader.dailyValueIntakeReference) {
      dailyValueIntakeReference = this.multiLangPipe.transform(nutrientHeader['dailyValueIntakeReference']);
    }

    let attributeKey = 'product.targetMarket';
    if (this.smartLabelService.isProductEntity) {
      attributeKey = 'targetMarket';
    }

    //console.log("dilyvalue", dailyValueIntakeReference)
    let result = {
      "ctrlName": "conditional",
      "config": {
        "source": "entityInformation",
        "action": "show",
        "operator": "matches",
        "mapping": {
          "attributeKey": attributeKey
        },
        "attributeValue": "840",
        "class": "smartlabel-nutrition-table"
      },
      "controls": [
        {
          "ctrlName": "rich-text",
          "config": {
            "class": "smartlabel-rich-text",
            "content": `<h2 class="table-header m-0 text-center">${supplementFactsText}</h2>`
          }
        },
        supplementFactsList,
        {
          "ctrlName": "rich-text",
          "config": {
            "class": "smartlabel-rich-text p-10 f-12",
            "content": `${footerText} ${dailyValueIntakeReference ? `${dailyValueIntakeReference}` : ''}`
          }
        }
      ]
    }
    //console.log("result", result)
    return result;
  }

  /**
   * get supplements facts table
   * @param index [nutrientHeader index]
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getSupplementFactsList(index: number = 0) {
    let servingSizeText = [
      {
        "languageCode": "en",
        "value": "Serving Size"
      },
      {
        "languageCode": "fr",
        "value": "Portion"
      },
      {
        "languageCode": "fr_US",
        "value": "Portion"
      },
      {
        "languageCode": "en_US",
        "value": "Serving Size"
      }
    ]
    let perContainer = [
      {
        "languageCode": "en",
        "value": "Servings Per Container"
      },
      {
        "languageCode": "fr",
        "value": "Portions Par Contenant"
      },
      {
        "languageCode": "fr_US",
        "value": " Portions Par Contenant"
      },
      {
        "languageCode": "en_US",
        "value": "Servings Per Container"
      }
    ];
    let dailyValue = [
      {
        "languageCode": "en",
        "value": "% Daily Value*"
      },
      {
        "languageCode": "fr",
        "value": "% valeur quotidienne*"
      },
      {
        "languageCode": "fr_US",
        "value": "% valeur quotidienne*"
      },
      {
        "languageCode": "en_US",
        "value": "% Daily Value*"
      }
    ];
    let eachServing = [
      {
        "languageCode": "en",
        "value": "Each Serving Contains"
      },
      {
        "languageCode": "fr",
        "value": "Chaque Portion Contient"
      },
      {
        "languageCode": "fr_US",
        "value": "Chaque Portion Contient"
      },
      {
        "languageCode": "en_US",
        "value": "Each Serving Contains"
      }
    ];

    //serving size list item
    let servingSize = this.getServingSizeListItem(index);
    let servingSizeConfig;
    if (servingSize && servingSize.length > 0) {
      //console.log("servingsize", servingSize)
      let text = this.multiLangPipe.transform(servingSizeText);
      let perContainerText = this.multiLangPipe.transform(perContainer);
      servingSizeConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none" detail="false">
           <ion-note slot="start" mode="ios" class="value"><b>${text} ${servingSize[0]}</b></ion-note>
          </ion-item>
          ${servingSize[1] ? `<ion-item lines="none" detail="false">
          <ion-note slot="start" mode="ios" class="value"><b>${perContainerText} ${servingSize[1]}</b></ion-note>
         </ion-item>` : ''}`,
          "class": "smartlabel-border-width-2x serving-size"
        }
      }
    }

    let dailyValueText = this.multiLangPipe.transform(dailyValue);
    let eachServingText = this.multiLangPipe.transform(eachServing);

    let eachServingConfig = {
      "ctrlName": "list-item",
      "config": {
        "label": `<ion-item lines="none" detail="false">
        <ion-note slot="start" mode="ios"><span class="f-w-700 f-12">${eachServingText}</span></ion-note>
        <ion-note slot="end" style="align-self:center" mode="ios"><span class="f-w-700 f-12">${dailyValueText}</span></ion-note>      </ion-item>`,
        "class": "smartlabel-border-width-2x"
      }
    }
    //Calorie List item
    let calories = this.getCalories(index);

    let calorieConfig;
    if (calories && Array.isArray(calories) && calories.length > 0) {
      calorieConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none" detail="false">
              <ion-grid>
                <ion-row>
                  <ion-col size="6">
                   ${calories[0]} 
                  </ion-col>
                  <ion-col size="3">
                    <div class="ion-text-end">
                    ${calories[1]}
                    </div>
                  </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>`,
        }
      }
    }

    let widthClass = "smartlabel-border-width-2x";
    let nutrientsList = this.getNutrientsList(index);
    if (nutrientsList && nutrientsList.length > 0) {
      //console.log("lastindex", nutrientsList[nutrientsList.length-1])
      nutrientsList[nutrientsList.length - 1].config.class = widthClass;
    } else if (calorieConfig) {
      calorieConfig['config']['class'] = 'smartlabel-border-width-2x';
    }
    let additionalNutrientsList = this.getAdditionalNutrientsList(index);
    if (additionalNutrientsList && additionalNutrientsList.length > 0) {
      //console.log("additional", additionalNutrientsList[additionalNutrientsList.length-1])
      additionalNutrientsList[additionalNutrientsList.length - 1].config.class = widthClass;
    }
    let result = {
      "ctrlName": "list",
      "title": "",
      "config": {
        "class": "smartlabel-list supplement-facts",
      },
      "controls": [
        ...(servingSizeConfig ? [servingSizeConfig] : []),
        ...(eachServingConfig ? [eachServingConfig] : []),
        ...(calorieConfig ? [calorieConfig] : []),
        ...nutrientsList,
        ...additionalNutrientsList
      ]
    };
    return result;
  }

  /**
   * get nutrients values [nutrientCode, nutrientValue, measurementUnitCode, dailyValueIntakePercent] for nutrientCode
   * @param index [nutrientHeader index]
   * @param code [nutrientCode]
   */
  getSupplementNutrients(index, nutrientCode) {
    let result;
    let [nutrientName, measurementPrecision, quantityContained, dailyValueIntakePercent] = ['', '', '', ''];

    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;

    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === nutrientCode);
    }
    //console.log("nutrientDetail",index, nutrientCode, nutrientDetail, nutrientIndex)
    //get nutrientName
    if (nutrientIndex != -1) {

      let nutrientItem = nutrientDetail[nutrientIndex];
      //console.log("nutrientIndex", nutrientIndex, nutrientItem)

      //1.get nutrientName by nutrientCode
      nutrientName = this.getNutrientName(nutrientDetailPath, nutrientIndex);

      //2. measurementPrecision ex. Less than
      if (nutrientItem.hasOwnProperty('measurementPrecision')) {
        if (nutrientItem['measurementPrecision'] != 'EXACT') {
          measurementPrecision = this.getMeasurementPrecision(nutrientDetailPath, nutrientIndex);
        }
      }

      //3. quantityContained ex. 5mg
      quantityContained = this.getQuantityContained(nutrientItem, nutrientDetailPath, nutrientIndex);
      //4. ex. 0%
      dailyValueIntakePercent = this.getDailyValueIntakePercent(nutrientItem);

      result = [nutrientName, measurementPrecision, quantityContained, dailyValueIntakePercent];

    }
    //console.log("result", result, nutrientCode)
    //if item not found return undefined
    return result;
  }

  /**
   * get serving size values
   * @param index [nutrientHeader index]
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getServingSizeListItem(index: number) {
    let result;
    let nutrientHeaderPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}`
    let path = nutrientHeaderPath.split('.');
    const nutrientHeader = this.appService.findObjectByPath(this.smartLabelData, path);
    let servingSize = '';
    let numberOfServings;
    //console.log("nutrientHeader", nutrientHeader);
    if (nutrientHeader) {
      //console.log("nutrientHeader", nutrientHeader)
      if (nutrientHeader && nutrientHeader.hasOwnProperty('servingSize') && Array.isArray(nutrientHeader['servingSize'])) {
        if (nutrientHeader['servingSize'].length > 0) {
          nutrientHeader['servingSize'].map((element, servingSizeIndex) => {
            let measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientHeaderPath}.servingSize.${servingSizeIndex}.measurementUnitCode | mapTo: listItemName}}`);
            if (servingSizeIndex == 0) {
              servingSize += `${element['value']} ${measurementUnitCode}`;
            } else {
              servingSize += ` (${element['value']} ${measurementUnitCode})`;
            }
          })
        }
      }
      if (nutrientHeader.hasOwnProperty("numberOfServings")) {

        numberOfServings = nutrientHeader['numberOfServings'];
      }
      result = [servingSize, numberOfServings];
    }
    //console.log("Result", result)
    return result;
  }

  ngOnDestroy() {
    if (this.servingSizeSubscription) {
      this.servingSizeSubscription.unsubscribe();
    }
  }

  /**
   * get fixed nutrientsList
   * @param index 
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getNutrientsList(index: number = 0) {
    let result: Array<any> = [];
    this.supplementFactsList.map((item) => {
      //console.log("item", item, this.getMicroNutrients(0,item))
      //console.log("micronutrients index", index)
      let listItem = this.getSupplementNutrients(index, item);
      if (listItem) {
        //console.log("listitem", listItem)
        result.push({
          "ctrlName": "list-item",
          "config": {
            "label": `
            <ion-item lines="none" detail="false">
            <ion-grid>
              <ion-row>
                <ion-col size="6">
                 ${listItem[0]} ${listItem[1]} 
                </ion-col>
                <ion-col size="3">
                  <div class="ion-text-end">
                  ${listItem[2]}
                  </div>
                </ion-col>
                <ion-col size="3">
                  <div class="ion-text-end">
                  ${listItem[3]}
                  </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>`,
            "class": ''
          }
        })
      }

    });
    return result;
  }

  /**
   * get additional nutrients codes list-items
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getAdditionalNutrientsList(index: number = 0) {
    let result: Array<any> = [];  // array of config for codes

    //find out additional nutrients from this.supplementsFactsList
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`;
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    //GET ADDITIONAL NUTRIENTCODES
    if (nutrientDetail) {
      //console.log("nutrientDetail", nutrientDetail)
      if (Array.isArray(nutrientDetail) && nutrientDetail.length > 0) {
        nutrientDetail.map((item) => {
          if (item.hasOwnProperty("nutrientTypeCode") && item.nutrientTypeCode) {
            //check calories('ENER-') manually 9not added in supplementFactsList array)
            if (item.nutrientTypeCode != 'ENER-') {
              let additionalIndex = this.supplementFactsList.findIndex(element => element === item.nutrientTypeCode);

              if (additionalIndex === -1) {
                //console.log("additionalIndex", additionalIndex, item)
                let listItem = this.getSupplementNutrients(index, item.nutrientTypeCode);
                if (listItem) {
                  // console.log("listitem additional", listItem)
                  result.push({
                    "ctrlName": "list-item",
                    "config": {
                      "label": `
                      <ion-item lines="none" detail="false">
                      <ion-grid>
                        <ion-row>
                          <ion-col size="6">
                           ${listItem[0]} ${listItem[1]} 
                          </ion-col>
                          <ion-col size="3">
                            <div class="ion-text-end">
                            ${listItem[2]}
                            </div>
                          </ion-col>
                          <ion-col size="3">
                            <div class="ion-text-end">
                            ${listItem[3]}
                            </div>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </ion-item>`,
                      "class": ''
                    }
                  });
                }
              }
            }
          }
        });
      }
    }
    return result;
  }


  /**
  * get nutrientName value using nutrientIndex ex. Cholestrol
  * @param nutrientDetailPath [Path to a particulat nutrientDetail]
  * @param nutrientIndex [index of element matching nutrientCode]
  * @author Radhika Agnihotri
  * @task QLIKTAG-3720
  */
  getNutrientName(nutrientDetailPath, nutrientIndex) {
    let result = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.nutrientTypeCode| mapTo: listItemName}}`);
    return result;
  }

  /**
   * get measurementPrecision value using nutrientIndex ex. Less Than
   * @param nutrientDetailPath [Path to a particulat nutrientDetail]
   * @param nutrientIndex [index of element matching nutrientCode]
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getMeasurementPrecision(nutrientDetailPath, nutrientIndex) {
    let result = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.measurementPrecision| mapTo: listItemName}}`);
    return result;
  }

  /**
   * get quantityContained value using nutrientIndex ex. 5mg
   * @param nutrientItem [nutrientDetail object matching nutrientCode]
   * @param nutrientDetailPath [Path to a particulat nutrientDetail]
   * @param nutrientIndex [index of element matching nutrientCode]
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getQuantityContained(nutrientItem: object, nutrientDetailPath: string, nutrientIndex: number) {
    let result = '';
    if (nutrientItem.hasOwnProperty('quantityContained') && nutrientItem['quantityContained'].length > 0) {
      if (nutrientItem['quantityContained'][0].hasOwnProperty('value')) {
        let value = nutrientItem['quantityContained'][0]['value'];
        let measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.quantityContained.0.measurementUnitCode | mapTo: listItemName}}`);
        // result += measurementUnitCode;
        result = `${value} ${measurementUnitCode}`
      }
    }
    return result;
  }

  /**
   * get dailyValueIntakePercent value using nutrientItem
   * @param nutrientItem [nutrientDetail object matching nutrientCode]
   * @author Radhika Agnihotri
   * @task QLITKAG-3720
   */
  getDailyValueIntakePercent(nutrientItem) {
    let result = '';
    if (nutrientItem.hasOwnProperty('dailyValueIntakePercent')) {
      result = `${nutrientItem['dailyValueIntakePercent']}%`;
    }
    return result;
  }

  /**
   * get calorie value for given nutrientHeader index
   * @param index [nutrientHeader index]
   * @author Radhika Agnihotri
   * @task QLIKTAG-3720
   */
  getCalories(index) {
    let calorieValue: string;
    let calorieText: string;
    let result;
    //get index
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`;
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;
    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === 'ENER-');
    }

    if (nutrientIndex != -1) {
      let calorieItem = nutrientDetail[nutrientIndex];
      if (calorieItem.hasOwnProperty('quantityContained') && calorieItem['quantityContained'].length > 0) {
        if (calorieItem['quantityContained'][0].hasOwnProperty('value')) {
          calorieValue = calorieItem['quantityContained'][0]['value'];
        }
      }

      if (calorieItem.hasOwnProperty('nutrientTypeCode') && calorieItem.nutrientTypeCode && calorieItem.nutrientTypeCode != '') {
        calorieText = this.getNutrientName(nutrientDetailPath, nutrientIndex);
      }
    }
    if (calorieText && calorieText != '' && calorieValue) {
      result = [calorieText, calorieValue];
    }
    return result;
  }


  /**
   * @author Radhika Agnihotri
   * @task QLIKTAG-3722
   */
  getIngredientsList() {
    let result;
    let path = this.ingredientsPath.split(".");
    let ingredients = this.appService.findObjectByPath(this.smartLabelData, path);

    if (ingredients) {
      if (ingredients.hasOwnProperty('foodAndBeverageIngredient') && ingredients.foodAndBeverageIngredient && Array.isArray(ingredients.foodAndBeverageIngredient) && ingredients.foodAndBeverageIngredient.length > 0) {
        result = this.ingredientListConfig(ingredients.foodAndBeverageIngredient);
        //console.log("final result", result)
        //console.log("ingreidentslistconfig", result)
      } else if (ingredients.hasOwnProperty('ingredientStatement') && ingredients.ingredientStatement) {
        result = this.getIngredientsByStatement(ingredients.ingredientStatement);

      }
    }
    return result;
  }


  /**
   * 
   * @param ingredientsList 
   * @param listIndex 
   * @param level 
   * @author Radhika Agnihotri
   * @task QLIKTAG-3722
   */
  ingredientListConfig(ingredientsList: Array<any>, listIndex?, level = 0) {

    // console.log("listIndex", listIndex)
    const nestedKey = 'subIngredient';
    let nestedIndex;
    const pageLinks = [
      { "url": `p/${this.pageService.pageAlias}?detail=ingredient-supplement`, "type": "detail" },
      { "url": `p/${this.pageService.pageAlias}?detail=sub-ingredient-supplement`, "type": "detail" },
      { "url": `p/${this.pageService.pageAlias}?detail=sub-ingredient-supplement`, "type": "detail" }]

    let result = {
      "ctrlName": "list",
      "config": {
        "class": "smartlabel-list ingredient-list"
      },
      "controls": []
    }

    if (ingredientsList && ingredientsList.length > 0) {

      let listItem;
      let itemListConfig;
      ingredientsList.forEach((item, index) => {
        nestedIndex = listIndex ? `${listIndex}_${index}` : `${index}`;
        listItem = {
          "ctrlName": "list-item",
          "config": {
            "label": item.hasOwnProperty('ingredientName') ?
              `${this.multiLangPipe.transform(item.ingredientName)}` : '',
            "content": '',
            "url": this.formatPageLinkURL(pageLinks[level], nestedIndex),
            "class": "ingredient-item"
          },
          "controls": []
        }
        if (item.hasOwnProperty(nestedKey)) {
          level = level + 1;
          itemListConfig = this.ingredientListConfig(item[nestedKey], nestedIndex, level);


          if (level != 0) {
            level = level - 1;
          }
          if (itemListConfig) {
            if (itemListConfig.hasOwnProperty("config") && itemListConfig.config.hasOwnProperty("class")) {
              itemListConfig.config.class = "smartlabel-list ingredient-list nested-ingredients-list";
            }
            listItem.controls.push(itemListConfig);
          }
        }

        result.controls.push(listItem);
      });
    }
    //console.log("result", result)
    return result;
  }

  /**
   * 
   * @param pageLink 
   * @param listIndex 
   * @author Radhika Agnihotri
   * @task QLIKTAG-3722
   */
  formatPageLinkURL(pageLink, listIndex) {
    //console.log("listIndex", listIndex)
    if (pageLink) {
      let link = JSON.parse(JSON.stringify(pageLink));
      if (listIndex) {

        if (link.hasOwnProperty('url')) {

          link.url += `&listIndex=${listIndex}`;
        }

      }
      return link;
    }
  }

  /**
   * get Ingredients by statement if array of ingredients not present
   * @param ingredientStatement 
   * @author Radhika Agnihotri
   * @task QLIKTAG-3722
   */
  getIngredientsByStatement(ingredientStatement) {
    let list: any;
    let controls = [];
    let ingredientsList;

    if (ingredientStatement) {
      let ingredientsByStatement = this.multiLangPipe.transform(JSON.parse(JSON.stringify(ingredientStatement)));
      if (typeof (ingredientsByStatement) === 'string') {
        ingredientsList = ingredientsByStatement.split(/,(?![^(]*\))/);
      }
    }
    if (ingredientsList && ingredientsList.length > 0) {

      for (const ingredient of ingredientsList) {
        controls.push(
          {
            "ctrlName": "list-item",
            "config": {
              "label": ingredient
            }
          },
        )
      }
      if (controls.length > 0) {
        list = {
          "ctrlName": "list",
          "title": "Ingredients List",
          "config": {
            "class": "smartlabel-list ingredient-list"
          },
          "controls": controls
        }
      }
    }
    return list;
  }
}
